import { useMutation } from "@tanstack/react-query";

import { workbenchStipulationsApi } from "../../../api/client";

export interface PorExceptionInput {
  approvalId: string;
  applicantPk?: number;
}

/** Mutation hook for setting POR exception on a stipulation. */
export function usePorExceptionMutation() {
  return useMutation({
    mutationFn: async (input: PorExceptionInput): Promise<void> => {
      if (!input.applicantPk) {
        throw new Error("applicantPk is required for POR exception");
      }
      await workbenchStipulationsApi.updatePorException(input.approvalId, input.applicantPk, {});
    },
  });
}
